function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #191915;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M48.14,0H1.86C.79,0,0,.86,0,1.86v46.28c0,1.07.86,1.86,1.86,1.86h46.28c1.07,0,1.86-.86,1.86-1.86V1.86C50,.79,49.14,0,48.14,0ZM49,48.14c0,.42-.32.86-.86.86H1.86c-.42,0-.86-.32-.86-.86V1.86c0-.42.32-.86.86-.86h46.28c.42,0,.86.32.86.86v46.28Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M15.77,17.24c4.15-1.31,8.22-1.36,8.98-1.35,0,0,4.68-.04,8.95,1.32,4.27,1.36,7.02,3.81,7.02,3.81h2.87s-3.02-3.33-8.82-5.37h0c-5.24-1.85-9.18-1.83-9.9-1.8-.34,0-4.6-.14-9.86,1.7-5.46,1.72-9.09,5.47-9.09,5.47h2.87s2.38-2.32,6.98-3.78Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M46.34,20.77c-.15-.09-.31-.13-.49-.13s-.33.04-.49.13c-.15.09-.27.21-.36.36-.09.15-.13.31-.13.49s.05.34.13.49c.09.15.21.27.36.35s.31.13.48.13.33-.04.48-.13h.02c.15-.08.27-.2.36-.35s.13-.32.13-.49-.04-.34-.13-.49-.21-.27-.36-.36ZM46.58,22.03c-.08.13-.18.23-.31.3s-.26.11-.41.11-.28-.04-.41-.11h0c-.13-.07-.23-.17-.3-.3-.08-.13-.11-.27-.11-.42s.04-.29.11-.41c.07-.13.17-.23.3-.3s.27-.11.41-.11.28.04.41.11.23.17.3.3.11.27.11.41c0,.15-.04.29-.11.42Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M46.01,21.67c.08-.03.14-.08.18-.14s.06-.13.06-.2c0-.06,0-.11-.04-.16-.03-.05-.07-.09-.11-.12-.05-.03-.12-.04-.21-.04h-.38v1.2h.19v-.51h.14-.02s.05.05.1.13l.04.07.16.31h.22l-.2-.37c-.05-.09-.09-.14-.13-.17ZM45.81,21.57h-.13v-.41h.14c.07,0,.11,0,.14.03.03.02.05.04.06.07,0,.03.02.06.02.09,0,.06-.02.11-.05.15-.03.05-.09.07-.18.07Z"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "26.86 27.88 22.4 21.59 18.92 21.59 18.92 31.62 21.74 31.62 21.79 25.4 26.4 31.62 29.69 31.62 29.69 21.6 26.84 21.61 26.86 27.88"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "43.58 21.62 40.7 21.62 37.76 24.58 35.22 21.62 31.86 21.62 35.92 26.45 30.82 31.65 33.7 31.65 37.24 28.02 40.27 31.63 43.72 31.65 39.08 26.15 43.58 21.62"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "11.78 25.75 15.86 21.61 12.95 21.61 8.79 25.83 8.79 21.62 5.92 21.62 5.91 31.65 8.79 31.65 8.79 28.78 9.93 27.63 13.3 31.64 16.74 31.64 12.19 26.26 11.78 25.75"
});

function SvgJungQuelleKnx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJungQuelleKnx);
export default __webpack_public_path__ + "static/media/jung_quelle_knx.1d2abf6de0ae25ffe410332d9bc34902.svg";
export { ForwardRef as ReactComponent };